"use client"

import { Star } from "lucide-react"
import { Button } from "@/components/ui/button"
import type { CategoryFilterRatingOption } from "@/services/woo-commerce-service"
import { cn } from "@/utilities"

interface RatingFilterProps {
  options: CategoryFilterRatingOption[]
  value: number | null
  onChange: (value: number | null) => void
}

const STAR_VALUES = [1, 2, 3, 4, 5] as const

export const RatingFilter = ({
  options,
  value,
  onChange,
}: RatingFilterProps) => {
  if (options.length === 0) {
    return (
      <div className='space-y-2'>
        <p className='font-semibold text-gray-800 text-sm'>Avaliação mínima</p>
        <p className='text-gray-500 text-xs'>Nenhuma avaliação disponível.</p>
      </div>
    )
  }

  return (
    <div className='space-y-2'>
      <p className='font-semibold text-gray-800 text-sm'>Avaliação mínima</p>
      <div className='space-y-1'>
        <Button
          className='w-full justify-between'
          onClick={() => onChange(null)}
          type='button'
          variant={value === null ? "default" : "ghost"}
        >
          <span>Todas</span>
        </Button>

        {options.map((option) => {
          const isSelected = value === option.value

          return (
            <Button
              aria-pressed={isSelected}
              className='w-full justify-between'
              key={option.value}
              onClick={() => onChange(option.value)}
              type='button'
              variant={isSelected ? "default" : "ghost"}
            >
              <span className='flex items-center gap-2'>
                <span aria-hidden='true' className='flex items-center gap-0.5'>
                  {STAR_VALUES.map((starValue) => (
                    <Star
                      className={cn(
                        "h-3.5 w-3.5",
                        starValue <= option.value
                          ? "fill-amber-400 text-amber-400"
                          : "text-gray-300"
                      )}
                      key={`${option.value}-${starValue}`}
                    />
                  ))}
                </span>
                <span>{option.label}</span>
              </span>
              <span className='text-gray-500 text-xs'>({option.count})</span>
            </Button>
          )
        })}
      </div>
    </div>
  )
}
